export const createObj = (key, value) => {
  const obj = new Object();
  obj[key] = value;
  return obj;
};
